import { AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IBaseService } from '../../../core/service/ibase-service';
import { AbstractBaseAddUpdateComponent } from '../../../core/component/abstract-base-add-update-component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { StateConstant } from '../../../core/constant/state-constant';
import { CountryConstant } from '../../../core/constant/country-constant';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
import { CommonSelectListService } from '../../../shared/service/common-select-list.service';
import { ModuleUrlsConstant } from '../../../shared/add-refresh/constant/module-urls-constant';
import { ConfirmDialogService } from '../../../shared/confirm-dialog-box/service/confirm-dialog.service';
import { ACLService } from '../../../shared/AclService/acl.service';
import { ResponseCode } from '../../../core/constant/response-code';
import { SystemConfigService } from '../../../system-config/service/system-config.service';
import { SystemConfigSettingModel } from '../../../shared/model/system-config-setting-model';
import { VendorModuleParamConfigModel } from '../../../modules/vendor-registration/modal/vendor-module-param-config-model';
import { VendorDetailModal } from '../../../modules/vendor-registration/modal/vendor-detail-modal';
import { SalesOrderListComponent } from '../../../modules/sales-order/sales-order-list/sales-order-list.component';
import { BranchLocationComponent } from '../../../modules/party/branch-location/branch-location.component';
import { TermsOfPayment } from '../../../modules/party/modal/terms-of-delivery-const';
import { countryModel, VendorModal } from '../../../modules/vendor-registration/modal/vendor-Modal';
import { UserModal } from '../../../modules/user/modal/user-modal';
import { PartyDetailsBranchModel } from '../../../modules/party/modal/party-details-branch-model';
import { VendorService } from '../../../modules/vendor-registration/service/vendor.service';
import { ProductTypeModel } from '../../../modules/product-type/model/product-type.model';
import { PartyTypeModal } from '../../../modules/party-type/modal/party-type-modal';
@Component({
  selector: 'app-vendor-add-update',
  templateUrl: './vendor-add-update.component.html',
  styleUrls: ['./vendor-add-update.component.css']
})
export class VendorAddUpdateComponent  extends AbstractBaseAddUpdateComponent<VendorModal>
implements OnInit, AfterContentInit, AfterViewInit {
private readonly MODULE_PARAM_CONFIG_KEY: string = 'party';
public propertyUrls = ModuleUrlsConstant;
moduleParams = new VendorModuleParamConfigModel(this.moduleParamConfigGlob);
public formGroup: FormGroup;
public data: VendorModal;
private ngbRef: NgbModalRef;
private targetContactIndex = -1;
public stateList = StateConstant;
public countryList = CountryConstant;
public contactData: VendorDetailModal;
public isSelectedSameAddress: boolean;
@ViewChild(SalesOrderListComponent) soListComponent: SalesOrderListComponent;
public productTypeList: Array<ProductTypeModel>;
partyTypeList: Array<PartyTypeModal>;
public selectedPartyType: PartyTypeModal;

selectedState: {
  id: number;
  name: string;
};
selectedCountry: countryModel;
bankDetailsVisible = true;
filterUrl = this.propertyUrls.filterDataUrl.saleOrderFilterCustomerWise.filterUrl;
getFilterListUrl = '';
systemParam: SystemConfigSettingModel = new SystemConfigSettingModel(this.systemConfigService);

@ViewChild(BranchLocationComponent) branchChild: BranchLocationComponent;
termsOfPaymentsList = TermsOfPayment;
vendorId;
userName: string;
password: string;
constructor(
  public service: VendorService,
  public router: Router,
  public toastrService: ToastrService,
  private activeRoute: ActivatedRoute,
  private formBuilder: FormBuilder,
  private ngbModalService: NgbModal,
  private aclService: ACLService,
  public cdr: ChangeDetectorRef,
  private systemConfigService: SystemConfigService,
  public commonService: CommonSelectListService,
  public confirmationDialogService: ConfirmDialogService,
  private moduleParamConfigGlob: ModuleParamGlobConfigService
) {
  super(toastrService, router);
}

ngOnInit() {
  let id = this.activeRoute.snapshot.paramMap.get('id');
  this.vendorId = id; 
  this.init();
  this.getProductTypes();
}

getService(): IBaseService<VendorModal> {
  return this.service;
}

async setData(data: VendorModal) {
  this.data = data;
  this.getPartyTypeList();
  if (!this.isUpdateComponent) {
    if (this.data && !this.data.country) {
      this.data.selectedCountry = new countryModel();
      this.data.selectedCountry = this.countryList.find((country) => country.name.toUpperCase() === 'INDIA');
    }
  }
  if (this.isUpdateComponent) {
    if (
      this.data &&
      this.data.partyType &&
      this.data.partyType.key &&
      (this.data.partyType.key === 'Customer' || this.data.partyType.key === 'Both')
    ) {
      this.moduleParams.paramData.transports.isVisible = true;
      this.moduleParams.paramData.salesHead.isVisible = true;
    }
    if (this.data && this.data.state) {
      this.selectedState = this.stateList.find((s) => s.name.toUpperCase() === this.data.state.toUpperCase());
    }
    if (this.data && this.data.country) {
      this.data.selectedCountry = new countryModel();
      this.data.selectedCountry = this.countryList.find(
        (country) => country.name.toUpperCase() === this.data.country.toUpperCase()
      );
    }
    if (!this.isUserAllow) {
      if (this.data && this.data.salesHead) {
        let curr = await this.aclService.getLoggedInUser().toPromise();
        this.data.currentSalesHead = new UserModal();
        this.data.currentSalesHead = curr.data;
        const salesHead = this.data.salesHead.find((sh) => sh.staffid === this.data.currentSalesHead.staffid);
        if (salesHead) {
          this.data.salesHead = new Array<UserModal>();
          this.data.salesHead.push(salesHead);
        }
      }
    }
  }
}

getData(): VendorModal {
  return this.data;
}

public getModuleHomeUrl(): string {
  return '/module/vendor/vendor-registration';
}

onCancel() {
  super.onCancel();
}

public getActiveRoute(): any {
  return this.activeRoute;
}

public getNewModal(): VendorModal {
  return new VendorModal();
}

public getFormGroup(): FormGroup {
  return this.formGroup;
}

setValidation() {
  this.formGroup = this.formBuilder.group({
    vendorName: ['', Validators.required],
    gstNumber: ['', [Validators.minLength(15), Validators.maxLength(15)]],
    panNumber: [''],
    state: [''],
    country: [],
    productType: [''],
    partyType: [''],
    vendorWebsite: [''],
    billingAddress: ['', Validators.required],
    billingAddress2: ['', Validators.required],
    billingAddress3: ['', Validators.required],
    shippingAddress: ['', Validators.required],
    shippingAddress2: ['', Validators.required],
    shippingAddress3: ['', Validators.required],
    bankName: [''],
    ifscCode: [''],
    accountHolderName: [''],
    accountNumber: ['', this.numberOnlyValidation],
    transports: [''],
    salesHead: [],
    vendorCode: [],
    segment: [''],
    termsOfPayment: [''],
    branchDetails: this.formBuilder.array([]),
    userName: ['', Validators.required],
    password: ['', Validators.required]
  });
}

removeAddValidationCheck(name: string, required: boolean) {
  this.formGroup.get(`${name}`).clearValidators();
  if (required) this.formGroup.get(`${name}`).setValidators([Validators.required]);
  this.formGroup.get(`${name}`).updateValueAndValidity();
}

formControlValueChanged() {
  const bankNameControl = this.formGroup.get('bankName');
  const ifscControl = this.formGroup.get('ifscCode');
  const accHolderControl = this.formGroup.get('accountHolderName');
  const accNumberControl = this.formGroup.get('accountNumber');

  this.formGroup.get('partyType').valueChanges.subscribe((type) => {
    if ((type ? type.id : 0) === 2) {
      bankNameControl.setValidators([Validators.required]);
      ifscControl.setValidators([Validators.required]);
      accHolderControl.setValidators([Validators.required]);
      accNumberControl.setValidators([this.numberOnlyValidation, Validators.required]);
    } else {
      bankNameControl.clearValidators();
      ifscControl.clearValidators();
      accHolderControl.clearValidators();
      accNumberControl.setValidators([this.numberOnlyValidation]);
    }
    bankNameControl.updateValueAndValidity();
    ifscControl.updateValueAndValidity();
    accHolderControl.updateValueAndValidity();
    accNumberControl.updateValueAndValidity();
  });
}

public getId(): number {
  return this.data.id;
}

get f() {
  return this.formGroup.controls;
}

onAddClick(content) {
  this.targetContactIndex = -1;
  this.contactData = new VendorDetailModal();
  this.ngbRef = this.ngbModalService.open(content, { size: 'lg', backdrop:'static' });
}

onContactSave(eventData: VendorDetailModal) {
  if (!this.data.contactDetails || this.data.contactDetails.length === 0) {
    this.data.contactDetails = new Array<VendorDetailModal>();
  }

  if (this.targetContactIndex >= 0) {
    this.data.contactDetails[this.targetContactIndex] = eventData;
  } else {
    this.data.contactDetails.push(eventData);
  }

  this.targetContactIndex = -1;
  this.ngbRef.close();
}

public onEdit(index: number, content) {
  this.targetContactIndex = index;
  this.contactData = Object.assign({}, this.data.contactDetails[index]);
  this.ngbRef = this.ngbModalService.open(content, { size: 'lg' , backdrop:'static'});
}

public onDelete(i: number) {
  if (confirm('Are you sure?')) {
    this.data.contactDetails.splice(i, 1);
  }
}

public onContactCancel(event) {
  this.ngbRef.close();
}

onStateSelect(event) {
  this.data.state = undefined;
  if (event) this.data.state = event.name;
}

onSubmit() {
  this.submitted = true;
  if (this.branchChild && !this.isUpdateComponent) {
    this.data.branchDetails = new Array<PartyDetailsBranchModel>();
    this.data.branchDetails = JSON.parse(JSON.stringify(this.branchChild.mainData.branchDetails));
  }
  if (this.branchChild && this.isUpdateComponent) {
    this.data.branchDetails = JSON.parse(JSON.stringify(this.branchChild.mainData.branchDetails));
  }
  if (this.selectedPartyType) {
    let tempPartyType = {
      id: this.selectedPartyType.id,
    };
    this.data.partyType = tempPartyType;
    console.log('PArty Type =>', this.data.partyType);
  }
  if (this.formGroup.invalid) {
    this.toastrService.warning('Please fill all required fields', 'Error');
    return;
  }
  if (!this.data.contactDetails || this.data.contactDetails.length === 0) {
    this.toastrService.warning('Add at least on Contact Detail!!', 'Error');
    return;
  }

  super.onSubmit();
}

onCountrySelect() {
  this.formGroup.controls.state.enable();
  this.data.country = undefined;
  if (this.data.selectedCountry && this.data.selectedCountry.name.toUpperCase() !== 'INDIA') {
    this.formGroup.controls.state.disable();
  }
  if (this.data.selectedCountry) {
    this.data.country = this.data.selectedCountry.name;
  }
}

onAddressSameClick() {
  this.isSelectedSameAddress = !this.isSelectedSameAddress;
  if (this.data && this.isSelectedSameAddress) {
    this.data.shippingAddress = this.data.billAddress;
    this.data.shippingAddress2 = this.data.billAddress2;
    this.data.shippingAddress3 = this.data.billAddress3;
  } else {
    this.data.shippingAddress = undefined;
    this.data.shippingAddress2 = undefined;
    this.data.shippingAddress3 = undefined;
  }
}

ngAfterContentInit() {
  this.moduleParams = new VendorModuleParamConfigModel(this.moduleParamConfigGlob);
}

onSalesOrderTabSelect() {
  /*this.activeRoute.params.subscribe((params: Params) => {
    const id = +params['id'];
    this.getFilterListUrl = '';
    this.getFilterListUrl = this.filterUrl + id;
  });*/
}

onAddNewSalesOrder(salesOrderTmp: any) {
  this.ngbRef = this.ngbModalService.open(salesOrderTmp, { windowClass: 'xlModal', backdrop:'static' });
}

onSubmitContinue() {
  this.submitted = true;
  if (this.getFormGroup().invalid) {
    return;
  }
  if ((this.data && !this.data.contactDetails) || this.data.contactDetails.length === 0) {
    this.toastrService.warning('Add at least on Contact Detail!!', 'Error');
    return;
  }

  if (this.branchChild) {
    this.data.branchDetails = new Array<PartyDetailsBranchModel>();
    console.log(this.branchChild.mainData.branchDetails);
    this.data.branchDetails = JSON.parse(JSON.stringify(this.branchChild.mainData.branchDetails));
  }
  let tempPartyType = {
    id: this.selectedPartyType.id,
  };
  this.data.partyType = tempPartyType;
  console.log('PArty Type =>', this.data);
  if (confirm('Are you sure you want to save this record?')) {
    this.onSaveAndContinue(this.getData());
  }
}

onSaveAndContinue(modal: VendorModal) {
  this.getService()
    .save(modal)
    .subscribe(
      (response) => {
        if (response.responseCode != ResponseCode.OK) {
          this.onResponseError(response.responseMessage);
          return;
        }
        const responseParty = response.data;
        this.router.navigate(['/module/party/addUpdateParty/' + responseParty.id]);
        this.toastrService.success('Data has been save successfully.', 'Success');
      },
      (error) => {
        this.onResponseError(error.message);
      }
    );
}

onRefresh() {}

ngAfterViewInit() {}

onModelCancel() {
  this.ngbRef.close();
}

checkUserRole() {
  this.aclService.getLoggedInUser().subscribe((response) => {
    this.validateResponse(response, () => {
      this.data.currentSalesHead = new UserModal();
      this.data.currentSalesHead = response.data;
      /*** Sales Head */
      if (!this.isUserAllow) {
        this.formGroup.controls.salesHead.disable();
        if (!this.isUpdateComponent) {
          if (!this.data) this.data = new VendorModal();
          if ((this.data && !this.data.salesHead) || this.data.salesHead.length === 0) {
            this.data.salesHead = new Array<UserModal>();
            this.data.salesHead.push(this.data.currentSalesHead);
          }
        }
        if (this.isUpdateComponent) {
          if (this.data && this.data.salesHead) {
            const salesHead = this.data.salesHead.find((sh) => sh.staffid === this.data.currentSalesHead.staffid);
            if (salesHead) {
              this.data.salesHead = new Array<UserModal>();
              this.data.salesHead.push(salesHead);
            }
          }
        }
      }
    });
  });
}
fillPanNumber() {
  if (this.data.gstNumber.length >= 12) {
    this.data.panNumber = this.data.gstNumber.slice(2).substr(0, 10);
  }
}

getProductTypes() {
  if (!this.productTypeList) {
    this.commonService.getProductTypeList().subscribe((response) => {
      this.validateResponse(response, () => {
        this.productTypeList = new Array<ProductTypeModel>();
        this.productTypeList = response.dataList;
      });
    });
  }
}

getPartyTypeList() {
  this.commonService.getPartyTypeList().subscribe((res) => {
    this.partyTypeList = new Array<PartyTypeModal>();
    this.partyTypeList = res.dataList;
  });
}
}